import React from 'react';
import * as S from './styles';

export const Footer = () => {
  return (
    <S.Footer>
    </S.Footer>
  );
};
